import { render, staticRenderFns } from "./VueButton3.vue?vue&type=template&id=0d214f7b&"
import script from "./VueButton3.vue?vue&type=script&lang=js&"
export * from "./VueButton3.vue?vue&type=script&lang=js&"
import style0 from "./VueButton3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VueButton3.vue"
export default component.exports